var _ellipse, _circle, _circle2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoFavorites = function SvgNoFavorites(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 120 120"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.628,
    cy: 60.199,
    fill: "#D5DBDE",
    rx: 59,
    ry: 59.199
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53.846,
    cy: 53.846,
    r: 52.346,
    stroke: "#ABB6BD",
    strokeDasharray: "1 10",
    strokeWidth: 3,
    transform: "scale(.99831 1.00168)rotate(45 49.742 65.282)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.846,
    cy: 53.846,
    r: 49.846,
    stroke: "#ABB6BD",
    strokeDasharray: "1 60",
    strokeWidth: 8,
    transform: "scale(.99831 1.00168)rotate(45 49.742 65.282)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F07D00",
    strokeWidth: 0.5,
    d: "m89.236 29.99 1.416.084.083 1.42 2.032 2.04-.31-5.272-5.253-.31z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F07D00",
    fillRule: "evenodd",
    d: "M50.12 41.03c-3.601-.256-6.793 1.156-9.105 3.404-4.562 4.428-5.968 12.429-.315 17.956l.05.05 18.287 16.192c.267.237.615.368.976.368.36 0 .709-.131.976-.368l18.286-16.193q.027-.023.052-.05c5.623-5.496 4.21-13.497-.337-17.93-2.307-2.25-5.492-3.67-9.09-3.422-3.236.226-6.629 1.786-9.888 4.99 0 0-3.64-4.554-9.891-4.997",
    clipRule: "evenodd"
  })));
};
export default SvgNoFavorites;